
    <form [formGroup]="validityEditForm" (ngSubmit)="onUpdatePromoValidity()">
    
        <div class="buss-info-details content-details-blk">
         <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"> 
        <div class="row g-0">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
            >
              <h4 class="form-item-label" translate>
                pages.Promocodehistory.Validity
              </h4>
            </div>
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 align-self-center"
            >
            <div class="form-item-input">
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    [matDatepicker]="picker"
                    formControlName="promocodeEndDateTime"
                  />
                  <!-- <span matPrefix>{{'pages.Creditlinereport.From' | translate }}</span> -->
                  <mat-datepicker-toggle matSuffix [for]="picker">
                    <mat-icon matDatepickerToggleIcon
                      >keyboard_arrow_down</mat-icon
                    >
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
          </div>
      </div>
      </div>
      

      <div class="form-footer">
        <ul class="list-inline text-center">
          <li class="list-inline-item">
            <button
              mat-raised-button
             
              color="primary"
              type="submit"
              class="rounded-0"
              [disabled]="checkSubmitDisplayed()"
            >
              <span translate class="translate">pages.newRetailer.update</span>
            </button>
          </li>
          <li class="list-inline-item">
            <button
              mat-stroked-button
              color="primary"
              type="button"
              class="rounded-0"
              (click)="onCancel()"
            >
              <span translate class="translate">pages.newRetailer.cancel</span>
            </button>
          </li>
          <li class="list-inline-item"></li>
        </ul>
      </div>
    </div>
    </form>
